import classNames from 'classnames';
import React from 'react';
import styles from './banner.css';
import { renderIcon } from './colored_icon';
import { IconInfo } from './icons';
import { Inline } from './layout';

export function Banner({
  variant = 'primary',
  icon = IconInfo,
  children,
  actions,
  bordered,
  fullWidth,
}: {
  variant?: 'primary' | 'grey2' | 'grey3' | 'white';
  icon?: React.ComponentType | React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  bordered?: boolean;
  fullWidth?: boolean;
}) {
  return (
    <div
      className={classNames(
        styles.banner,
        styles[variant],
        bordered && styles.bordered,
        fullWidth && styles.fullWidth,
      )}
    >
      <div className={styles.icon}>{renderIcon(icon)}</div>
      <div className={styles.content}>{children}</div>
      <div className={styles.actions}>
        <Inline spacing={8}>{actions}</Inline>
      </div>
    </div>
  );
}
